export default __webpack_public_path__ + "static/media/CapaSetUpGroupName.37a0a803.svg";